// extracted by mini-css-extract-plugin
export var box = "DonationPrompt-module--box--3Nw0n";
export var text = "DonationPrompt-module--text--ptJVH";